import React from "react";
import { useAppSelector } from "../app/hooks";
import CreateMenu from "./menu/CreateMenu";
import AppDrawer from "../components/drawer/Drawer";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateSetting from "./setting/CreateSetting";
import CreateRights from "./rights/CreateRights";
import CreateWhyChoose from "./whychoose/CreateWhyChoose";
import CreateGallery from "./gallery/CreateGallery";
import CreateClientLogo from "./clientlogo/CreateClientLogo";

const Drawers = () => { 
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    menuForm: <CreateMenu />,
    testimonialForm: <CreateTestimonial />,
    settingForm: <CreateSetting />,
    rightsForm: <CreateRights />,
    whychooseForm: <CreateWhyChoose />,
    galleryForm: <CreateGallery />,
    clientLogoForm: <CreateClientLogo />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
